import { BaseConst } from './baseConst';

export class CmConst extends BaseConst {

    // 模型
    static MainObject = 'MainObject';
    static ComponentAssemblyName = 'ComponentAssemblyName';
    static AssemblyName = 'AssemblyName';
    static GeneratingAssembly = 'GeneratingAssembly';
    // 权限
    static Authorizations = 'Authorizations';
    // 依赖be
    static Category = 'Category';
    static DependentEntityId = 'DependentEntityId';
    static DependentEntityName = 'DependentEntityName';
    static DependentEntityPackageName = 'DependentEntityPackageName';
    // 生成时间戳字段
    static IsUsingTimeStamp = 'IsUsingTimeStamp';
    // 变量
    static Variables = 'Variables';
    // 操作
    static Description = 'Description';
    static RequestElements = 'RequestElements';
    static RequestChildElements = 'RequestChildElements';
    static IsGenerateComponent = 'IsGenerateComponent';
    // 是否启用流程
    static EnableApproval = 'EnableApproval';
    static TriggerPointType = 'TriggerPointType';
    static GetExecutingDataStatus = 'GetExecutingDataStatus';
    static RunOnce = 'RunOnce';
    // 构件
    static ComponentId = 'ComponentId';
    static ComponentName = 'ComponentName';
    static ComponentPkgName = 'ComponentPkgName';

    static ChildTriggerInfo = 'ChildTriggerInfo';
}
